export const company = {
  brand: 'Market Fusion Innovations',
  legalName: 'Market Fusion Innovations LLC',
  email: 'contact@marketfusioninnovations.com',
  domain: 'marketfusioninnovations.com',
  addressLines: ['3-A Mykhaila Hryshka Street', 'Kyiv, 02140', 'Ukraine'],
  address: '3-A Mykhaila Hryshka Street, Kyiv, 02140, Ukraine',
  mapUrl: 'https://www.google.com/maps/search/?api=1&query=3-A+Mykhaila+Hryshka+Street+Kyiv+02140+Ukraine',
};

export const pdfFlowsUrl = 'https://pdf-flows.com';

export const navLinks = [
  { label: 'Company', to: '/#company' },
  { label: 'Products', to: '/#products' },
  { label: 'PDF Flows', to: '/pdf-flows' },
  { label: 'InstruKit', to: '/instrukit' },
  { label: 'Contact', to: '/#contact' },
];
